import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Se já estiver na home, faz scroll suave; caso contrário, navega para /#id
  function scrollTo(id) {
    setMenuOpen(false);
    if (location.pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${id}`);
    }
  }

  const textColor = scrolled ? '#1e293b' : 'rgba(255,255,255,0.85)';
  const logoColor = scrolled ? '#1e293b' : '#fff';

  return (
    <header style={{ ...styles.nav, ...(scrolled ? styles.navScrolled : {}) }}>
      <div style={styles.navInner}>
        <a href="/" style={{ ...styles.logo, color: logoColor }}>
          <div style={{
            ...styles.logoIcon,
            background: scrolled ? '#eff6ff' : 'rgba(255,255,255,0.15)',
          }}>📦</div>
          <span style={{ ...styles.logoText, color: logoColor }}>
            BringHub <strong>Frete</strong>
          </span>
        </a>

        <nav style={{ ...styles.links, ...(menuOpen ? styles.linksOpen : {}) }}>
          {[
            ['funcionalidades', 'Funcionalidades'],
            ['integrações', 'Integrações'],
            ['planos', 'Planos'],
            ['calculadora', 'Calculadora'],
            ['contato', 'Contato'],
          ].map(([id, label]) => (
            <button key={id} style={{ ...styles.navLink, color: textColor }} onClick={() => scrollTo(id)}>
              {label}
            </button>
          ))}
          <a href="/docs" style={{ ...styles.navLink, color: textColor }}>API Docs</a>
          <a href="/login" style={{
            ...styles.btnLogin,
            background: scrolled ? '#1e40af' : '#fff',
            color: scrolled ? '#fff' : '#1e40af',
          }}>Acessar Painel</a>
        </nav>

        <button style={{ ...styles.hamburger, color: logoColor }} onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>
    </header>
  );
}

const styles = {
  nav: {
    position: 'fixed',
    top: 0, left: 0, right: 0,
    zIndex: 100,
    transition: 'background 0.2s, box-shadow 0.2s',
    padding: '0 24px',
  },
  navScrolled: {
    background: 'rgba(255,255,255,0.97)',
    boxShadow: '0 1px 12px rgba(0,0,0,0.08)',
    backdropFilter: 'blur(8px)',
  },
  navInner: {
    maxWidth: '1200px',
    margin: '0 auto',
    height: '68px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: {
    display: 'flex', alignItems: 'center', gap: '10px',
    textDecoration: 'none',
    transition: 'color 0.2s',
  },
  logoIcon: {
    width: '36px', height: '36px',
    borderRadius: '9px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '18px',
    transition: 'background 0.2s',
  },
  logoText: {
    fontSize: '18px', fontWeight: '400', letterSpacing: '-0.3px',
    transition: 'color 0.2s',
  },
  links: {
    display: 'flex', alignItems: 'center', gap: '4px',
  },
  linksOpen: {},
  navLink: {
    background: 'none', border: 'none',
    fontSize: '14px', fontWeight: '500',
    cursor: 'pointer', padding: '8px 12px',
    borderRadius: '6px',
    fontFamily: 'inherit',
    textDecoration: 'none',
    transition: 'color 0.2s',
  },
  btnLogin: {
    marginLeft: '8px',
    padding: '8px 18px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    textDecoration: 'none',
    transition: 'background 0.2s, color 0.2s',
    border: 'none',
  },
  hamburger: {
    display: 'none',
    background: 'none', border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    transition: 'color 0.2s',
  },
};
